import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function Login({ onAuthenticate }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();

    
    fetch('https://bot-battle-server.vercel.app/users')
      .then(response => response.json())
      .then(users => {
        
        const user = users.find(user => user.username === username && user.password === password);
        if (user) {
          alert('Login successful!');
          onAuthenticate(); 
          navigate('/'); 
        } else {
          setError('Invalid username or password');
        }
      })
      .catch(error => console.error('Error fetching users:', error));
  };

  return (
    <div className="flex justify-center mt-44">
      <form onSubmit={handleSubmit} className="border-slate-500 border-2 w-96 rounded-lg flex gap-12 flex-col bg-slate-200 p-4">
        <div className="text-center text-2xl">
          <h2>LOGIN PAGE</h2>
        </div>
        <div className="flex gap-7 ml-7">
          <label htmlFor="username">Username:</label>
          <input
            type="text"
            id="username"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="rounded-md text-center"
            required
          />
        </div>
        <div className="flex gap-7 ml-7">
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="rounded-md text-center"
            required
          />
        </div>
        {error && <p className="text-red-500 text-center">{error}</p>}
        <div className="flex gap-7 justify-center mb-7 text-xl">
          <button type="submit" className="text-blue-500">Login</button>
        </div>
      </form>
    </div>
  );
}

export default Login;
